export const estadosFederativosOptions = [
  { value: 1, label: "Aguascalientes" },
  { value: 2, label: "Baja California" },
  { value: 3, label: "Baja California Sur" },
  { value: 4, label: "Campeche" },
  { value: 5, label: "Chiapas" },
  { value: 6, label: "Chihuahua" },
  { value: 7, label: "Coahuila" },
  { value: 8, label: "Colima" },
  { value: 9, label: "Distrito Federal" },
  { value: 10, label: "Durango" },
  { value: 11, label: "Guerrero" },
  { value: 12, label: "Guanajuato" },
  { value: 13, label: "Hidalgo" },
  { value: 14, label: "Jalisco" },
  { value: 15, label: "México" },
  { value: 16, label: "Michoacán" },
  { value: 17, label: "Morelos" },
  { value: 18, label: "Nayarit" },
  { value: 19, label: "Nuevo León" },
  { value: 20, label: "Oaxaca" },
  { value: 21, label: "Puebla" },
  { value: 22, label: "Querétaro" },
  { value: 23, label: "Quintana Roo" },
  { value: 24, label: "San Luis Potosí" },
  { value: 25, label: "Sinaloa" },
  { value: 26, label: "Sonora" },
  { value: 27, label: "Tabasco" },
  { value: 28, label: "Tamaulipas" },
  { value: 29, label: "Tlaxcala" },
  { value: 30, label: "Veracruz" },
  { value: 31, label: "Yucatán" },
  { value: 32, label: "Zacatecas" },
  { value: 33, label: "Otro" },
]

export const paisesOptions = [
  { value: 1, label: "Afganistán" },
  { value: 2, label: "Albania" },
  { value: 3, label: "Alemania" },
  { value: 4, label: "Andorra" },
  { value: 5, label: "Angola" },
  { value: 6, label: "Antigua y Barbuda" },
  { value: 7, label: "Arabia Saudita" },
  { value: 8, label: "Argelia" },
  { value: 9, label: "Argentina" },
  { value: 10, label: "Armenia" },
  { value: 11, label: "Australia" },
  { value: 12, label: "Austria" },
  { value: 13, label: "Azerbaiyán" },
  { value: 14, label: "Bahamas" },
  { value: 15, label: "Bahrein" },
  { value: 16, label: "Bangladesh" },
  { value: 17, label: "Barbados" },
  { value: 18, label: "Bielorrusia" },
  { value: 19, label: "Bélgica" },
  { value: 20, label: "Belice" },
  { value: 21, label: "Benín" },
  { value: 22, label: "Bhután" },
  { value: 23, label: "Bolivia" },
  { value: 24, label: "Bosnia y Herzegovina" },
  { value: 25, label: "Botswana" },
  { value: 26, label: "Brasil" },
  { value: 27, label: "Brunei Darussalam" },
  { value: 28, label: "Bulgaria" },
  { value: 29, label: "Burkina Faso" },
  { value: 30, label: "Burundi" },
  { value: 31, label: "Cabo Verde" },
  { value: 32, label: "Camboya" },
  { value: 33, label: "Camerún" },
  { value: 34, label: "Canadá" },
  { value: 35, label: "Chad" },
  { value: 36, label: "Chile" },
  { value: 37, label: "China" },
  { value: 38, label: "Chipre" },
  { value: 39, label: "Colombia" },
  { value: 40, label: "Comoras" },
  { value: 41, label: "Congo" },
  { value: 42, label: "Costa Rica" },
  { value: 43, label: "Côte d Ivoire" },
  { value: 44, label: "Croacia" },
  { value: 45, label: "Cuba" },
  { value: 46, label: "Dinamarca" },
  { value: 47, label: "Dominica" },
  { value: 48, label: "Ecuador" },
  { value: 49, label: "Egipto6" },
  { value: 50, label: "El Salvador" },
  { value: 51, label: "Emiratos Árabes Unidos" },
  { value: 52, label: "Eritrea" },
  { value: 53, label: "Eslovaquia" },
  { value: 54, label: "Eslovenia" },
  { value: 55, label: "España" },
  { value: 56, label: "Estados Unidos de América" },
  { value: 57, label: "Estonia" },
  { value: 58, label: "Etiopía" },
  { value: 59, label: "ex República Yugoslava de Macedonia" },
  { value: 60, label: "Federación Rusa" },
  { value: 61, label: "Fiji" },
  { value: 62, label: "Filipinas" },
  { value: 63, label: "Finlandia" },
  { value: 64, label: "Francia" },
  { value: 65, label: "Gabón" },
  { value: 66, label: "Gambia" },
  { value: 67, label: "Georgia" },
  { value: 68, label: "Ghana" },
  { value: 69, label: "Granada" },
  { value: 70, label: "Grecia" },
  { value: 71, label: "Guatemala" },
  { value: 72, label: "Guinea" },
  { value: 73, label: "Guinea-Bissau" },
  { value: 74, label: "Guinea Ecuatorial" },
  { value: 75, label: "Guyana" },
  { value: 76, label: "Haití" },
  { value: 77, label: "Honduras" },
  { value: 78, label: "Hungría" },
  { value: 79, label: "India" },
  { value: 80, label: "Indonesia" },
  { value: 81, label: "Irán, República Islámica de" },
  { value: 82, label: "Iraq" },
  { value: 83, label: "Irlanda" },
  { value: 84, label: "Islandia" },
  { value: 85, label: "Islas Marshall" },
  { value: 86, label: "Islas Salomón" },
  { value: 87, label: "Israel" },
  { value: 88, label: "Italia" },
  { value: 89, label: "Jamahiriya Árabe Libia" },
  { value: 90, label: "Jamaica" },
  { value: 91, label: "Japón" },
  { value: 92, label: "Jordania" },
  { value: 93, label: "Kazajistán" },
  { value: 94, label: "Kenya" },
  { value: 95, label: "Kirguistán" },
  { value: 96, label: "Kiribati" },
  { value: 97, label: "Kuwait" },
  { value: 98, label: "Lesoto" },
  { value: 99, label: "Letonia" },
  { value: 100, label: "Líbano" },
  { value: 101, label: "Liberia" },
  { value: 102, label: "Liechtenstein" },
  { value: 103, label: "Lituania" },
  { value: 104, label: "Luxemburgo" },
  { value: 105, label: "Madagascar" },
  { value: 106, label: "Malasia" },
  { value: 107, label: "Malaui" },
  { value: 108, label: "Maldivas" },
  { value: 109, label: "Malí" },
  { value: 110, label: "Malta" },
  { value: 111, label: "Marruecos" },
  { value: 112, label: "Mauricio" },
  { value: 113, label: "Mauritania" },
  { value: 114, label: "México" },
  { value: 115, label: "Micronesia, Estados Federados de" },
  { value: 116, label: "Mónaco" },
  { value: 117, label: "Montenegro" },
  { value: 118, label: "Mongolia" },
  { value: 119, label: "Mozambique" },
  { value: 120, label: "Birmania" },
  { value: 121, label: "Namibia" },
  { value: 122, label: "Nauru" },
  { value: 123, label: "Nepal" },
  { value: 124, label: "Nicaragua" },
  { value: 125, label: "Níger" },
  { value: 126, label: "Nigeria" },
  { value: 127, label: "Noruega" },
  { value: 128, label: "Nueva Zelanda" },
  { value: 129, label: "Omán" },
  { value: 130, label: "Países Bajos" },
  { value: 131, label: "Pakistán" },
  { value: 132, label: "Palaos" },
  { value: 133, label: "Panamá" },
  { value: 134, label: "Papúa Nueva Guinea" },
  { value: 135, label: "Paraguay" },
  { value: 136, label: "Perú" },
  { value: 137, label: "Polonia" },
  { value: 138, label: "Portugal" },
  { value: 139, label: "Qatar" },
  { value: 140, label: "Reino Unido de Gran Bretaña e Irlanda del Norte" },
  { value: 141, label: "República Árabe Siria" },
  { value: 142, label: "República Centroafricana" },
  { value: 143, label: "República Checa" },
  { value: 144, label: "República de Corea" },
  { value: 145, label: "República Democrática del Congo" },
  { value: 146, label: "República Democrática Popular Lao" },
  { value: 147, label: "República Dominicana" },
  { value: 148, label: "República de Moldova" },
  { value: 149, label: "República Popular Democrática de Corea" },
  { value: 150, label: "República Unida de Tanzania" },
  { value: 151, label: "Rumania" },
  { value: 152, label: "Ruanda" },
  { value: 153, label: "Saint Kitts y Nevis" },
  { value: 154, label: "Samoa" },
  { value: 155, label: "San Marino" },
  { value: 156, label: "Santa Lucía" },
  { value: 157, label: "Santo Tomé y Príncipe" },
  { value: 158, label: "San Vicente y las Granadinas" },
  { value: 159, label: "Senegal" },
  { value: 160, label: "Serbia" },
  { value: 161, label: "Seychelles" },
  { value: 162, label: "Sierra Leona" },
  { value: 163, label: "Singapur" },
  { value: 164, label: "Somalia" },
  { value: 165, label: "Sri Lanka" },
  { value: 166, label: "Sudáfrica" },
  { value: 167, label: "Sudán" },
  { value: 168, label: "Suecia" },
  { value: 169, label: "Suiza" },
  { value: 170, label: "Surinam" },
  { value: 171, label: "Suazilandia" },
  { value: 172, label: "Tailandia" },
  { value: 173, label: "Tayikistán" },
  { value: 174, label: "Timor-Leste" },
  { value: 175, label: "Togo" },
  { value: 176, label: "Tonga" },
  { value: 177, label: "Trinidad y Tobago" },
  { value: 178, label: "Túnez" },
  { value: 179, label: "Turkmenistán" },
  { value: 180, label: "Turquía" },
  { value: 181, label: "Tuvalu" },
  { value: 182, label: "Ucrania" },
  { value: 183, label: "Uganda" },
  { value: 184, label: "Uruguay" },
  { value: 185, label: "Uzbekistán" },
  { value: 186, label: "Vanuatu" },
  { value: 187, label: "Venezuela, República Bolivariana de" },
  { value: 188, label: "Viet Nam" },
  { value: 189, label: "Yemen" },
  { value: 190, label: "Yibuti" },
  { value: 191, label: "Zambia" },
  { value: 192, label: "Zimbabwe" },
]

export const estadosCivilesOptions = [
  { value: 1, label: "Soltero" },
  { value: 2, label: "Casado" },
  { value: 3, label: "Divorciado" },
  { value: 4, label: "Union Libre" },
  { value: 5, label: "Viudo" },
]
